'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:SearchClientsAndProspectsService
 * @description
 * # SearchClientsAndProspectsService
 * Controller of the thothAppApp
 */
angular.module('thothApp.services')
  .factory('SearchClientsAndProspects', ['$http', 'domain', 'BaseService', function ($http, domain, BaseService) {
    var BASE_ACTIVITY_URL = domain.name + '/api/v1/clients/search_clients_and_prospects';
    var baseService = new BaseService();

    baseService.initialize({
      baseUrl: BASE_ACTIVITY_URL,
      baseModelName: 'search_clients_and_prospect'
    });

    baseService.error = function(error) {
      baseService.baseError(error);
    };

    return baseService;
  }]);
